import { Map } from 'immutable';
import Essay from './model';

import {
  FETCH_ESSAY_SUCCESS,
} from './actions';

export default function WritingAssignmentActivityReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_ESSAY_SUCCESS:
      return onFetchEssaySuccess(state, action);
    default:
      return state;
  }
}

function onFetchEssaySuccess(state, action) {
  const { id, studentId, payload } = action;
  return state.set(`${id}-${studentId}`, new Essay(payload));
}



// WEBPACK FOOTER //
// ./data/WritingAssignment/Essay/reducer.js